const prefix = 'global-settings-schedule';

export const settingsTrackingIds = {
  officeHoursRowItem: `${prefix}-office-hours-row-item`,
  manageProvidersRowItem: `${prefix}-manage-providers-row-item`,
  manageOperatoriesRowItem: `${prefix}-manage-operatories-row-item`,
  appointmentTypesRowItem: `${prefix}-appointment-types-row-item`,
  serviceTypesRowItem: `${prefix}-service-types-row-item`,
  messageTemplatesRowItem: `${prefix}-message-templates-row-item`,
  customFieldsRowItem: `${prefix}-custom-fields-row-item`,
  cancellationPolicyRowItem: `${prefix}-cancellation-policy-row-item`,
  bookingSiteLinkRowItem: `${prefix}-booking-site-link-row-item`,
  officeHoursLocationAccordion: `${prefix}-office-hours-location-accordion`,
  appointmentTypesLocationRowItem: `${prefix}-appointment-types-location-row-item`,
  serviceTypesLocationRowItem: `${prefix}-service-types-location-row-item`,
  manageProvidersLocationRowItem: `${prefix}-manage-providers-location-row-item`,
  manageOperatoriesLocationRowItem: `${prefix}-manage-operatories-location-row-item`,
  scheduleDefinitionTemplatesRowItem: `${prefix}-schedule-definition-templates-location-row-item`,
  availabilityRowItem: `${prefix}-availability-row-item`,
  availabilityRulesAIRowItem: `${prefix}-ai-availability-rules-row-item`,
  serviceTypesAIRowItem: `${prefix}-ai-service-types-row-item`,
  assignedProviderForOperatorySaveBtn: `${prefix}:operatory:assign-provider-modal:save-btn`,
  assignedProviderForOperatoryCancelBtn: `${prefix}:operatory:assign-provider-modal:cancel-btn`,
};
